import styles from '../../styles/Search.module.css';

const FALLBACK_KEYWORDS = ['共同信息', '栽在溪水旁', '工作見證', '雙魚星謎', '4794', '聖靈果子', '修補時間的遺憾', '撒種', 'Bitcoin', '133'];

const Keyword = ({ keywords, pressKeyword }) => {
  const feed = keywords && keywords.length > 0 ? keywords : FALLBACK_KEYWORDS;

  return (
    <div className={`${styles.keywordHolder} `}>
      {feed.map((item, index) => (
        <div key={index} className={styles.keywordBtn} onClick={() => pressKeyword(item)}>{item}</div>
      ))}
    </div>
  );
};

export default Keyword;